import { render } from "./PostBacklink.vue?vue&type=template&id=34650bf5&scoped=true"
const script = {}

import "./PostBacklink.vue?vue&type=style&index=0&id=34650bf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34650bf5"]])

export default __exports__